<ng-select
    #theSelect
    class="pcg-select"
    [class.d-none]="showNativeSelect == null ? false : showNativeSelect"
    [multiple]="multiple"
    [placeholder]="placeholder ?? ''"
    [labelForId]="labelForId"
    [(ngModel)]="value"
    [items]="items"
    (change)="(onChange)"
    (touch)="(onTouched)"
    groupBy="groupBy"
    bindLabel="text"
    bindValue="value"
    [clearable]="clearable"
    [virtualScroll]="virtualScroll"
    [searchable]="!isMobile"
></ng-select>
<span class="disabled-only-text" [class.d-none]="showNativeSelect == null ? false : showNativeSelect">{{ text }}</span>

@if (showNativeSelect == null ? false : showNativeSelect) {
    <select
        #theNativeSelect
        class="form-control"
        [(ngModel)]="value"
        [id]="labelForId"
        [name]="labelForId"
        (change)="(onChange)"
        (touch)="(onTouched)"
        [disabled]="disabled"
    >
        @if (clearable) {
            <option [ngValue]="value === undefined ? undefined : null">{{ placeholder }}</option>
        }
        @for (item of items; track item) {
            <option [ngValue]="item.value">{{ item.text }}</option>
        }
    </select>
}
